<template>
  <div class="page-content">
    <h2>Join Meeting</h2>
    <div id="video-container">
      <video width="240" ref="localVideo" autoplay muted></video>
      <video width="240" v-for="(participant, id) in remoteStreams" :key="id" ref="participant.videoRef" autoplay></video>
    </div>
    <div class="controls">
      <button @click="toggleMute">🔇 Mute</button>
      <button @click="endCall">🚪 End Call</button>
    </div>
    <input v-model="guestToken" placeholder="Enter your token" />
    <button @click="joinMeeting">Join</button>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  data() {
    return {
      connection: null,
      room: null,
      localTrack: null,
      remoteStreams: [],
      isMuted: false,
      isHost: false,
      guestToken: this.$route.query.token,
      roomName: 'testroom',
    };
  },
  methods: {
    async joinMeeting() {
      JitsiMeetJS.init();
      const domain = 'meet.makna.ai';
      const options = {
        hosts: { domain, muc: `conference.${domain}` },
        serviceUrl: `https://${domain}/http-bind`,
        clientNode: 'custom-client',
      };

      const connection = new JitsiMeetJS.JitsiConnection(null, this.guestToken, options);
      this.connection = connection;
      connection.connect();

      connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED, this.onConnected);
    },
    onFailed() {},

    async onConnected() {
      this.room = this.connection.initJitsiConference(this.roomName, {});
      this.room.on(JitsiMeetJS.events.conference.TRACK_ADDED, this.onRemoteTrack);
      this.room.join();

      // Create local video/audio stream
      const { 1: localStream } = await JitsiMeetJS.createLocalTracks({ devices: ['audio', 'video'] });
      this.localTrack = localStream;
      this.$refs.localVideo.srcObject = new MediaStream([this.localTrack.getTrack()]);
      this.room.addTrack(this.localTrack);
    },

    onRemoteTrack(track) {
      if (track.isLocal()) return;
      track.attach(this.createVideoElement());
      this.remoteStreams.push({ id: track.getParticipantId(), videoRef: this.createVideoElement() });
    },

    createVideoElement() {
      const video = document.createElement('video');
      video.autoplay = true;
      document.getElementById('video-container').appendChild(video);
      return video;
    },

    toggleMute() {
      this.isMuted = !this.isMuted;
      if (!this.isMuted) {
        this.localTrack.unmute();
      } else {
        this.localTrack.mute();
      }
    },

    endCall() {
      this.room.leave();
      this.connection.disconnect();
    },
  },
};
</script>
